import React, { useEffect, useRef, useState } from "react";
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form';
import { Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createOfflineUser, updateOfflineUser, getOfflineUserByID, fetchStates } from "../../../../Services/User/User";
import { getTvApkProjectAll } from "../../../../Services/TvApksService/TvApkService";

const getTrimmedValue = (value) => (value ?? "").trim();

const getDisplayTvApks = (apks = []) => {
  const primary = apks.find(
    (apk) => apk.name?.toUpperCase() === "MM PRIMARY"
  );

  const kids = apks.find(
    (apk) =>
      ["MM KIDS", "MM KIDZ"].includes(
        apk.name?.toUpperCase()
      )
  );

  // If both PRIMARY and KIDS/KIDZ exist, combine them
  if (primary && kids) {
    return apks
      .filter((apk) => apk !== kids)
      .map((apk) =>
        apk === primary
          ? {
            ...apk,
            name: "MM PRIMARY & KIDZ",
            // optionally store both app ids
            combined_app_ids: [primary.app_id, kids.app_id],
          }
          : apk
      );
  }

  // If only one exists, show normally
  return apks;
};
const CreateUser = ({ isShow, close, type, userId, projectId }) => {
  const handleShow = () => setShow(true);
  const handleClose = () => { setShow(false); close() };
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [password, setPassword] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [userNameError, setuserNameError] = useState(false);
  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [contactName, setContactName] = useState("");
  const [contactNameError, setContactNameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [deviceLimitError, setDeviceLimitError] = useState("");
  const [schoolNameError, setSchoolNameError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [status, setStatus] = useState();
  const usernameRef = useRef(null);
  const userTypeRef = useRef(null);
  const mobileNumberRef = useRef(null);
  const emailRef = useRef(null);
  const contactNameRef = useRef(null);
  const [passwordShow, setPasswordShow] = useState(false);
  const [address, setAddress] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [stateData, setStateData] = useState([]);
  const [deviceLimit, setDeviceLimit] = useState(1);
  const [stateName, setStateName] = useState("");
  const [addressError, setAddressError] = useState(false);
  const [stateError, setStateError] = useState(false);
  const [tvApkList, setTvApkList] = useState([]);
  const addressRef = useRef(null);
  const schoolNameRef = useRef(null);
  const [city, setCity] = useState('');
  const [userType, setUserType] = useState("");
  const [userTypeError, setUserTypeError] = useState(false);
  const [cityError, setCityError] = useState(false);
  const [village, setVillage] = useState('');
  const [villageError, setVillageError] = useState(false);
  const [pincode, setPincode] = useState('');
  const [pincodeError, setPincodeError] = useState(false);
  const passwordRef = useRef(null);
  const deviceLimitRef = useRef(null);
  const stateRef = useRef(null);
  const cityRef = useRef(null);
  const villageRef = useRef(null);
  const pincodeRef = useRef(null);
  const [showUpdatePassword, setShowUpdatePassword] = useState(false);

  const handlePasswordShow = (e) => {
    if (e.target.checked) {
      setPasswordShow(true)
    } else {
      setPasswordShow(false)
    }
  };
  useEffect(() => {
    setShow(isShow)
  }, []);
  useEffect(() => {
    const loadData = async () => {
      try {
        // Fetch States
        const statesResponse = fetchStates().then((response) => {
          setStateData(response?.data?.data || []);
        });
        // Fetch TV APKs
        const projectResponse = await getTvApkProjectAll();

        if (projectResponse?.status) {
          const project = projectResponse.data.find(
            item => Number(item.id) === Number(projectId)
          );

          if (project) {
            setTvApkList(project.tvApks || []);
          }
        }

        // Fetch user details
        if (type === "EDIT" && isShow) {
          const userResponse = await getOfflineUserByID(userId);

          if (userResponse?.status) {
            const user = userResponse.data.user;

            setName(user.user_name);
            setEmail(user.email || "");
            setContactName(user.contact_name);
            setMobileNo(user.mobile_number);
            setStatus(user.active);
            setDeviceLimit(user.device_limit || 1);
            setAddress(user.address || "");
            setSchoolName(user.school_name || "");
            setStateName(user.state || "");
            setCity(user.city || "");
            setVillage(user.village || "");
            setPincode(user.pincode || "");

            // user_type contains app_id
            setUserType(user.user_type || "");
          }
        }
      } catch (err) {
        toast.error("Error loading data");
      }
    };

    if (isShow) {
      loadData();
    }
  }, [type, userId, isShow, projectId]);


  const handleSaveUser = async () => {
    const trimmedName = getTrimmedValue(name);
    const trimmedEmail = getTrimmedValue(email);
    const trimmedMobileNo = getTrimmedValue(mobileNo);
    const trimmedContactName = getTrimmedValue(contactName);
    const trimmedPassword = getTrimmedValue(password);
    const trimmedSchoolName = getTrimmedValue(schoolName);
    const trimmedCity = getTrimmedValue(city);
    const trimmedVillage = getTrimmedValue(village);

    if (
      !trimmedName ||
      !trimmedMobileNo ||
      !trimmedContactName ||
      ((type === "CREATE" || (type === "EDIT" && showUpdatePassword)) && !trimmedPassword) ||
      !trimmedSchoolName ||
      !trimmedCity ||
      !trimmedVillage ||
      !userType || !deviceLimit
    ) {
      setuserNameError(!trimmedName);
      setMobileNumberError(!trimmedMobileNo);
      setContactNameError(!trimmedContactName);
      setPasswordError((type === "CREATE" || (type === "EDIT" && showUpdatePassword)) && !trimmedPassword);
      setSchoolNameError(!trimmedSchoolName);
      setCityError(!trimmedCity);
      setVillageError(!trimmedVillage);
      setUserTypeError(!userType)
      setDeviceLimitError(!deviceLimit)
      let object = [
        {
          key: trimmedName,
          ref: usernameRef.current,
        },
        {
          key: trimmedMobileNo,
          ref: mobileNumberRef.current,
        },
        {
          key: trimmedContactName,
          ref: contactNameRef.current,
        },
        {
          key: trimmedPassword,
          ref: passwordRef.current,
        },
        {
          key: userType,
          ref: userTypeRef.current,
        },
        {
          key: trimmedSchoolName,
          ref: schoolNameRef.current,
        },
        {
          key: trimmedCity,
          ref: cityRef.current,
        },
        {
          key: trimmedVillage,
          ref: villageRef.current,
        },
        {
          key: deviceLimit,
          ref: deviceLimitRef.current,
        },
      ];
      if (type === "EDIT") {
        object = object.filter(item => item.key !== trimmedPassword);
      }
      for (let i = 0; i < object.length; i++) {
        if (!object[i].key) {
          object[i].ref.focus();
          break;
        }
      }
      return;
    }
    setIsLoading(true);
    setIsDisabled(true);

    const insertData = {
      userName: trimmedName,
      email: trimmedEmail,
      contactName: trimmedContactName,
      password: trimmedPassword,
      mobileNumber: mobileNo,
      device_limit: deviceLimit || 1,
      address: address,
      schoolName: schoolName,
      userType: userType,
      project_id: projectId,
      isPwUpdate: showUpdatePassword,
      state: stateName,
      city: city,
      village: village,
      pincode: pincode
    };

    try {
      let response;
      if (type === "CREATE") {
        insertData.password = trimmedPassword
        response = await createOfflineUser(insertData);
      } else {
        if (showUpdatePassword) {
          insertData.password = trimmedPassword
        }
        insertData.user_id = userId;
        insertData.status = status;
        response = await updateOfflineUser(insertData);
      }
      if (response.status) {
        toast.success(response.message);
        close();
      } else {
        toast.error(response.errorMessage);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
      setIsDisabled(false);
    }
  }

  return (
    <Modal show={show} onHide={handleClose} dialogClassName="modal-xl">
      <Modal.Header closeButton>
        <h5 className="modal-title">{type === "CREATE" ? "Add User" : "Edit User"}</h5>
      </Modal.Header>
      <Modal.Body>
        <form className="row g-3">
          <div className="col-6 px-3">
            <label htmlFor="NewUserName" className="form-label required"> User Name</label>
            <input
              id='NewUserName'
              type="text"
              className="form-control"
              placeholder="Enter User Name"
              value={name}
              ref={usernameRef}
              maxLength={35}
              onChange={(e) => {
                const value = e.target.value.replace(/\s/g, ""); // remove all spaces
                setName(value);

                if (userNameError && value.trim() !== '') {
                  setuserNameError(false);
                }
              }}
            />
            <Form.Control.Feedback type="invalid" style={{ display: userNameError ? 'block' : 'none' }}>
              User name is required
            </Form.Control.Feedback>
          </div>
          <div className="col-6 px-3">
            <label htmlFor="userAddress" className="form-label required">School Name/ AWC Name</label>
            <input
              type="address"
              className="form-control"
              id="userAddress"
              placeholder="Enter School Name/ AWC Name"
              value={schoolName}
              maxLength={200}
              ref={schoolNameRef}
              onChange={(e) => {
                setSchoolName(e.target.value)
                if (schoolNameError && e.target.value.trim() !== '') {
                  setSchoolNameError(false);
                }
              }}
            />
            <Form.Control.Feedback type="invalid" style={{ display: schoolNameError ? 'block' : 'none' }}>
              School Name/ AWC Name is required
            </Form.Control.Feedback>
          </div>
          <div className="col-6 px-3">
            <label htmlFor="name" className="form-label required">Contact Name</label>
            <input
              type="name"
              className="form-control"
              id="name"
              placeholder="Enter Contact Name"
              value={contactName}
              maxLength={200}
              ref={contactNameRef}
              onChange={(e) => {
                setContactName(e.target.value)
                if (contactNameError && e.target.value.trim() !== '') {
                  setContactNameError(false);
                }
              }}
            />
            <Form.Control.Feedback type="invalid" style={{ display: contactNameError ? 'block' : 'none' }}>
              Contact Name is required
            </Form.Control.Feedback>
          </div>
          <div className="col-6 px-3">
            <label htmlFor="NewMobileNo" className="form-label required">Contact Number</label>
            <input
              type="text"
              className="form-control"
              id="NewMobileNo"
              placeholder="Enter Contact Number"
              value={mobileNo}
              ref={mobileNumberRef}
              maxLength={10}
              onChange={(e) => {
                setMobileNo(e.target.value)
                if (mobileNumberError && e.target.value.trim() !== '') {
                  setMobileNumberError(false);
                }
              }}
            />
            <Form.Control.Feedback type="invalid" style={{ display: mobileNumberError ? 'block' : 'none' }}>
              Contact number is required
            </Form.Control.Feedback>
          </div>
          <div className="col-6 px-3">
            <label htmlFor="NewUserEmail" className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              id="NewUserEmail"
              placeholder="Enter Email"
              value={email}
              ref={emailRef}
              maxLength={35}
              onChange={(e) => {
                setEmail(e.target.value)
                if (emailError && e.target.value.trim() !== '') {
                  setEmailError(false);
                }
              }}
            />
            <Form.Control.Feedback type="invalid" style={{ display: emailError ? 'block' : 'none' }}>
              Email-ID is required
            </Form.Control.Feedback>
          </div>
          <div className="col-6 px-3">
            <label htmlFor="userCity" className="form-label required">SEC Name</label>
            <input
              type="text"
              className="form-control"
              id="userCity"
              placeholder="Enter SEC Name"
              value={city}
              ref={cityRef}
              maxLength={100}
              onChange={(e) => {
                setCity(e.target.value);
                if (cityError && e.target.value.trim() !== '') {
                  setCityError(false);
                }
              }}
            />
            <Form.Control.Feedback type="invalid" style={{ display: cityError ? 'block' : 'none' }}>
              SEC Name is required
            </Form.Control.Feedback>
          </div>

          <div className="col-6 px-3">
            <label htmlFor="userVillage" className="form-label required">Mandal</label>
            <input
              type="text"
              className="form-control"
              id="userVillage"
              placeholder="Enter Mandal"
              value={village}
              ref={villageRef}
              maxLength={100}
              onChange={(e) => {
                setVillage(e.target.value);
                if (villageError && e.target.value.trim() !== '') {
                  setVillageError(false);
                }
              }}
            />
            <Form.Control.Feedback type="invalid" style={{ display: villageError ? 'block' : 'none' }}>
              Enter Mandal
            </Form.Control.Feedback>
          </div>
          <div className="col-6 px-3">
            <label htmlFor="userAddress" className="form-label">Address</label>
            <input
              type="address"
              className="form-control"
              id="userAddress"
              placeholder="Enter Address"
              value={address}
              ref={addressRef}
              maxLength={200}
              onChange={(e) => {
                setAddress(e.target.value)
                if (addressError && e.target.value.trim() !== '') {
                  setAddressError(false);
                }
              }}
            />
            <Form.Control.Feedback type="invalid" style={{ display: addressError ? 'block' : 'none' }}>
              Address is required
            </Form.Control.Feedback>
          </div>
          <div className="col-6 px-3">
            <label htmlFor="userState" className="form-label">State</label>
            <select
              id="userState"
              className="form-select"
              value={stateName}
              ref={stateRef}
              onChange={(e) => {
                setStateName(e.target.value);
                if (stateError && e.target.value.trim() !== '') {
                  setStateError(false);
                }
              }}
            >
              <option value="">Select State</option>
              {stateData.map((state) => (
                <option key={state.id} value={state.state_name}>
                  {state.state_name}
                </option>
              ))}
            </select>
            <Form.Control.Feedback type="invalid" style={{ display: stateError ? 'block' : 'none' }}>
              State is optional
            </Form.Control.Feedback>
          </div>
          <div className="col-6 px-3">
            <label htmlFor="userType" className="form-label required">APK Type</label>
            <select
              id="userType"
              className="form-select"
              value={userType}
              onChange={(e) => setUserType(e.target.value)}
            >
              <option value="">Select APK Type</option>

              {getDisplayTvApks(tvApkList, userType).map((apk) => (
                <option key={apk.id} value={apk.app_id}>
                  {apk.name}
                </option>
              ))}
            </select>

            <Form.Control.Feedback
              type="invalid"
              style={{ display: userTypeError ? 'block' : 'none' }}
            >
              APK type is required
            </Form.Control.Feedback>
          </div>
          <div className="col-6 px-3">
            <label htmlFor="deviceLimit" className="form-label required">
              Device Limit
            </label>

            <input
              type="number"
              className="form-control"
              id="deviceLimit"
              placeholder="Enter Device Limit"
              value={deviceLimit}
              ref={deviceLimitRef}
              min={1}
              max={1000}
              onChange={(e) => {
                const value = e.target.value;

                if (value === "") {
                  setDeviceLimit("");
                  setDeviceLimitError("Device Limit is required");
                  return;
                }

                const num = Number(value);

                setDeviceLimit(num);

                if (num < 1) {
                  setDeviceLimitError("Minimum value is 1");
                } else if (num > 1000) {
                  setDeviceLimitError("Maximum value is 1000");
                } else {
                  setDeviceLimitError("");
                }
              }}
            />
            {deviceLimitError && (
              <div className="text-danger mt-1">
                {deviceLimitError}
              </div>
            )}
          </div>

          {type === "EDIT" &&
            <div className="col-6 px-3">
              <label htmlFor="UserStatus" className="form-label required">Status</label>
              <select
                id='UserStatus'
                className="form-select"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="" disabled>Select status</option>
                <option value="true">Activate</option>
                <option value="false">Deactivate</option>
              </select>
              <div className="user-status invalid-feedback">
                Please select status.
              </div>
            </div>}


          {/* <div className="col-6 px-3">
            <label htmlFor="userPincode" className="form-label">Pincode</label>
            <input
              type="text"
              className="form-control"
              id="userPincode"
              placeholder="Enter Pincode (Optional)"
              value={pincode}
              ref={pincodeRef}
              maxLength={10}
              onChange={(e) => {
                setPincode(e.target.value);
                if (pincodeError && e.target.value.trim() !== '') {
                  setPincodeError(false);
                }
              }}
            />
            <Form.Control.Feedback type="invalid" style={{ display: pincodeError ? 'block' : 'none' }}>
              Pincode is optional
            </Form.Control.Feedback>
          </div> */}

          {type !== "CREATE" &&
            <div className="col-6 px-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="showUpdatePassword"
                  checked={showUpdatePassword}
                  onChange={(e) => setShowUpdatePassword(e.target.checked)}
                />
                <label htmlFor="showUpdatePassword" className="form-check-label">
                  Update Password
                </label>
              </div>
            </div>}
          {(type === "CREATE" || showUpdatePassword) && (
            <div className="col-6 px--6">
              <label htmlFor="NewSystemUserPassword" className="form-label required">Password</label>
              {!passwordShow ? (<input
                type="password"
                className="form-control"
                id="NewSystemUserPassword"
                maxLength="35"
                placeholder="Enter Password"
                value={password}
                ref={passwordRef}
                onChange={(e) => {
                  setPassword(e.target.value)
                  if (passwordError && e.target.value.trim() !== '') {
                    setPasswordError(false);
                  }
                }}
              />) : (<input
                type="text"
                className="form-control"
                id="NewSystemUserPassword"
                placeholder="Enter Password"
                maxLength="35"
                value={password}
                ref={passwordRef}
                onChange={(e) => {
                  setPassword(e.target.value)
                  if (passwordError && e.target.value.trim() !== '') {
                    setPasswordError(false);
                  }
                }}
              />)}
              <div className="col-9 px-1">
                <div className="form-check">
                  <input
                    autoComplete="off"
                    className="form-check-input"
                    type="checkbox"
                    id="showPassword"
                    onChange={handlePasswordShow}
                    checked={passwordShow}
                  />
                  <label htmlFor="showPassword" className="form-check-label label-grey">
                    Show password
                  </label>
                </div>
              </div>
              <Form.Control.Feedback type="invalid" style={{ display: passwordError ? 'block' : 'none' }}>
                Password is required
              </Form.Control.Feedback>
            </div>)}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={() => handleClose()}  >
          Close
        </button>
        <button type="button" className="btn btn-primary" disabled={isDisabled} onClick={() => handleSaveUser()}  >Save</button>

      </Modal.Footer>
    </Modal>

  );
};
export default CreateUser;

